import { Component, Input, OnInit } from '@angular/core';
import { SmsCallDetails } from 'voxloud-types/dist/models';

import { LocaleService } from '../../../shell/locale.service';

@Component({
  selector: 'app-call-log-sms',
  templateUrl: './call-log-sms.component.html',
  styleUrls: ['./call-log-sms.component.scss'],
})
export class CallLogSmsComponent implements OnInit {
  public dateFormat = 'MM/dd/yy HH:mm';
  public locale: string;
  @Input() smsItems: SmsCallDetails[];
  constructor(private localeService: LocaleService) {}

  ngOnInit() {
    this.locale = this.localeService?.current;
  }
}
